// extracted by mini-css-extract-plugin
var _1 = "BirdviewCardHeader-moduleaiTitle__LSm7O";
var _2 = "BirdviewCardHeader-moduleheader__kC2sf";
var _3 = "BirdviewCardHeader-moduleinfo__u5UVb IconNG-moduleiconContainer__SxWZ0";
var _4 = "BirdviewCardHeader-moduletitle__AcDdY";
var _5 = "BirdviewCardHeader-moduletitleSkeleton__l4zCK Skeleton-moduleSkeleton__Mlrfv";
var _6 = "BirdviewCardHeader-moduletitleWrap__xHKLQ";
export { _1 as "aiTitle", _2 as "header", _3 as "info", _4 as "title", _5 as "titleSkeleton", _6 as "titleWrap" }
